import { Box, Paper, Typography, styled } from '@mui/material';
import React from 'react';
import ReactApexCharts from 'react-apexcharts';
import CircleIcon from '@mui/icons-material/Circle';

interface PieChartProps {
  data?: {
    name: string;
    value: number;
  }[];
}
const colors = ['#14B8A6', '#FFB020', '#D14343'];
const PieChart: React.FC<PieChartProps> = ({ data = [] }: PieChartProps) => {
  return (
    <Paper>
      <Box sx={{ padding: 2, borderBottom: '1px solid lightgray' }}>
        <Typography variant="body1" fontWeight="bold">
          สถานะเชื่อมต่อเครื่องสแกน
        </Typography>
        {/* <Typography variant="body2">เริ่มเวลา 5.00 AM ถึงเวลา 23.00 PM</Typography> */}
      </Box>
      <Box sx={{ padding: 2, display: 'flex', justifyContent: 'center' }}>
        <ReactApexCharts
          options={{
            colors: colors,
            chart: {
              width: 380,
              type: 'donut'
            },
            labels: data.map((data) => data.name),
            legend: {
              show: false
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200
                  },
                  legend: {
                    position: 'bottom'
                  }
                }
              }
            ],
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      show: true,
                      formatter: (val) => val
                    },
                    value: {
                      show: true,
                      formatter: (val) => val
                    }
                  }
                }
              }
            }
          }}
          series={data.map((data) => data.value)}
          type="donut"
          width={300}
          height={300}
        />
      </Box>
      {data.map((item, index) => (
        <DataBox key={`${item.name}-${index}`}>
          <Box display="flex">
            <CircleIcon sx={{ marginRight: 1 }} style={{ color: colors[index % data.length] }} />
            <Typography>{item.name}</Typography>
          </Box>
          <Typography>{item.value}</Typography>
        </DataBox>
      ))}
    </Paper>
  );
};

export default PieChart;

const DataBox = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  padding: 12
});
